import React from 'react';

import AlbumSlideshowShare from './AlbumSlideshowShare';
import withModal from '../modal/withModal';

const AlbumSlideshowShareModal = ({ ...props }) => {
  return <AlbumSlideshowShare {...props} />;
};

export const ALBUM_SLIDESHOW_SHARE_MODAL = 'modal/ALBUM_SLIDESHOW_SHARE_MODAL';

export default withModal(AlbumSlideshowShareModal, {
  name: ALBUM_SLIDESHOW_SHARE_MODAL,
  contentLabel: (
    <p className="w-100 text-center mb-0 h4">Share this slideshow</p>
  ),
  size: 'sm',
  type: 'full',
});
